<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      let classesArray = ['c-widget-control-bar-group'];
      if (!this.inline) classesArray.push('c-widget-control-bar-group--block');
      return classesArray;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-widget-control-bar-group';
</style>
